<template>
  <div>
<!--    <div class="box-image">-->
<!--      <img class="main-image" :src="mainImage" alt="Zdjęcie konkursu" />-->
<!--&lt;!&ndash;      <h1 class="main-header">Zaproś młodych do budowania<br /> lepszego jutra</h1>&ndash;&gt;-->
<!--    </div>-->
    <div ref="targetRef"></div>
    <section class="form-starter" id="rejestracja">
      <form>
        <b-container>
          <b-row align-h="center">
            <b-col cols="12" xl="10" class="d-flex form-starter-box flex-column">
              <div class="form-starter__wrapper" v-if="!sendForm">
                <svg class="shape-1" width="449" height="834" viewBox="0 0 449 834" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M634.397 400.56C660.445 407.381 686.472 408.339 712.198 410.717C767.578 415.83 822.962 421.992 878.75 420.931C890.043 420.706 900.852 422.704 910.998 428.039C934.734 440.487 947.961 466.614 944.005 493.543C940.109 519.793 919.133 541.35 892.571 545.395C883.43 546.785 874.1 546.633 864.833 546.851C810.887 548.153 757.406 541.922 703.748 537.852C700.126 537.556 696.381 537.508 692.823 538.014C692.026 538.141 690.565 541.726 691.058 542.28C695.433 547.018 699.991 551.632 704.855 555.997C733.918 582.069 763.102 608.016 792.164 634.088C797.706 639.068 803.187 644.173 807.933 649.835C826.301 671.994 827.941 701.681 812.496 725.255C797.906 747.53 770.691 757.874 744.214 751.239C731.313 748.013 720.364 741.261 710.512 732.406C662.116 688.872 613.842 645.213 565.262 601.864C549.993 588.275 533.867 575.678 517.986 562.832C515.278 560.619 511.768 557.545 508.22 560.891C506.569 562.44 505.844 565.714 505.791 568.184C505.392 594.298 504.933 620.412 505.087 646.585C505.318 694.612 495.969 741.129 483.119 787.041C480.876 795.012 477.775 803.11 473.38 810.04C452.871 842.089 407.45 841.509 387.204 809.295C381.155 799.686 377.497 789.143 377.149 777.662C376.67 763.651 376.068 749.702 376.387 735.687C377.343 693.707 378.791 651.724 379.992 609.742C380.154 603.26 380.069 596.717 379.739 590.174C379.541 586.347 374.745 583.772 371.499 585.759C365.191 589.67 359.006 593.828 352.883 597.986C314.616 624.357 276.102 650.359 236.044 673.897C224.835 680.48 213.504 686.94 201.676 692.167C176.98 703.12 151.141 703.334 125.28 697.314C117.356 695.491 109.363 691.692 102.718 686.962C74.0438 666.506 75.7406 625.634 105.627 607.132C113.589 602.227 122.355 599.172 131.555 597.349C141.737 595.337 150.928 590.984 159.253 584.781C202.348 552.466 245.443 520.09 288.476 487.59C289.701 486.66 289.877 484.375 290.546 482.706C287.151 477.286 281.015 477.801 275.979 476.832C214.869 465.504 153.759 454.485 92.589 443.59C84.4207 442.137 75.89 442.352 67.7217 440.9C57.7112 439.207 47.3943 437.638 37.9913 434.153C15.0673 425.591 0.813544 404.221 0.544674 380.27C0.271218 355.023 15.1097 333.488 39.3217 324.451C50.7229 320.213 62.6244 318.627 74.7745 317.905C104.72 316.133 133.953 321.029 163.127 326.482C186.711 330.905 210.356 335.143 233.879 339.442C235.875 331.225 230.402 328.22 226.767 324.467C192.394 289.093 158.02 253.719 123.463 218.53C107.755 202.474 94.1898 184.805 82.6441 165.524C75.7906 154.066 72.3097 141.67 72.7531 128.211C73.9651 89.1308 112.801 67.2638 146.445 87.2076C155.179 92.3622 162.998 99.1867 170.571 106.012C218.351 148.808 266.132 191.728 313.606 234.896C337.066 256.172 361.32 276.396 386.43 295.629C388.646 297.288 390.922 298.885 393.321 300.358C398.55 303.611 402.779 301.868 403.004 296.188C403.285 288.717 403.197 281.248 403.232 273.778C403.037 218.714 403.149 163.649 402.524 108.587C402.335 89.6975 404.663 71.2933 408.834 53.1294C414.153 29.9612 427.287 12.3211 450.151 4.02999C492.325 -11.3052 537.919 20.7575 533.167 65.5297C525.681 135.498 531.206 205.359 529.367 275.246C529.261 279.938 529.154 284.568 529.416 289.258C529.868 295.553 526.89 303.836 532.734 307.457C539.501 311.693 544.26 303.775 548.973 300.054C594.265 264.398 639.25 228.373 682.447 190.07C692.91 180.835 703.311 171.538 714.021 162.611C719.712 157.899 725.71 153.186 732.204 149.83C758.12 136.466 787.349 140.499 807.058 159.689C826.274 178.388 832.46 209.417 822.176 234.701C815.24 251.702 804.304 266.186 788.313 274.206C767.972 284.34 751.638 299.399 734.317 313.288C703.103 338.276 672.198 363.695 641.23 388.992C638.477 391.285 634.985 393.211 634.396 400.436L634.397 400.56Z" fill="#BDD4EF"/>
                </svg>
                <h2 class="form-starter__title">Formularz zgłoszeniowy</h2>
                <p class="form-starter__text">
                  Jesteś zainteresowany, zainteresowana udziałem w programie Solve for Tomorrow?
                  <br>Chcesz otrzymywać na bieżąco informacje o naszych działaniach i dodatkowe materiały
                  przydatne podczas lekcji?
                  <br><br>
                  Wypełnij krótki formularz zgłoszeniowy.
                </p>
                <b-col cols="12" lg="6" class="d-flex flex-column">
                  <div class="d-flex flex-column">
                    <div class="input-box">
                      <p>Nazwa szkoły/placówki <span class="color">*</span></p>
                      <b-input class="mb-4 input" required v-model="form.school_name"></b-input>
                    </div>
                    <div class="input-box select">
                      <p>Województwo <span class="color">*</span></p>
                      <b-select class="mb-4 input select" required :options="voivodeships" v-model="form.school_voivodeship" @blur.native="onBlur" @change.native="onSelectChange" @click.native="toggleDropdown"></b-select>
                      <span class="select-icon" :class="{ 'rotate': isSelectFocused }"></span>
                    </div>
                    <div class="input-box">
                      <p>Imię i nazwisko nauczyciela/nauczycielki/edukatora/edukatorki <span class="color">*</span></p>
                      <b-input class="mb-4 input" v-model="form.first_name"></b-input>
                    </div>
                    <div class="input-box">
                      <p class="mb-3">Zaznacz swoją rolę:</p>
                      <div class="d-flex justify-content-start">
                        <div class="radio-box d-flex flex-column">
                          <label class="input-control mt-0">
                            <input type="radio" name="position" value="Nauczyciel, nauczycielka" v-model="form.position" required />
                            <p class="input-control--text">Nauczyciel, nauczycielka</p>
                          </label>
                          <label class="input-control mt-0">
                            <input type="radio" name="position" value="Edukator, edukatorka" v-model="form.position" required />
                            <p class="input-control--text">Edukator, edukatorka</p>
                          </label>
                          <label class="input-control mt-0">
                            <input type="radio" name="position" value="Uczeń, uczennica" v-model="form.position" required />
                            <p class="input-control--text">Uczeń, uczennica</p>
                          </label>
                          <label class="input-control mt-0">
                            <input type="radio" name="position" value="Inne" v-model="form.position" required />
                            <p class="input-control--text">Inne</p>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="input-box">
                      <p>Adres e-mail <span class="color">*</span></p>
                      <b-input class="mb-4 input" required type="email" v-model="form.email"></b-input>
                    </div>
                    <div class="input-box">
                      <p>Numer telefonu</p>
                      <b-input class="mb-4 input"  v-model="form.phone"></b-input>
                    </div>
                  </div>
                  <label class="input-box d-flex align-items-center">
                    <input type="checkbox" name="regulation_consent" class="label" required v-model="form.regulation_consent" />
                    <p class="input-box--consent mt-1">Oświadczam, że zapoznałem/zapoznałam się z <a href="https://solvefortomorrow.pl/wp-content/uploads/2025/09/regulamin_Solve_for_Tomorrow_5_edycja.pdf" target="_blank">regulaminem</a> programu. <span class="color">*</span></p>
                  </label>
                  <label class="input-box d-flex align-items-center">
                    <input type="checkbox" name="personal_data_consent" class="label" required v-model="form.personal_data_consent" />
                    <p class="input-box--consent mt-1">Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. <span class="color">*</span></p>
                  </label>
                </b-col>
                <b-row v-if="validForm">
                  <b-col class="text-center my-5 error">
                    <h3>Wszystkie pola formularza oznaczone * oraz zgody muszą być wypełnione lub zaznaczone</h3>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col v-if="!sendForm" class="mt-5 mb-3 d-inline-flex justify-content-center">
                    <b-button @click="handleFormSubmit" class="button-new-primary" type="submit" variant="primary">
                      Wyślij
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12.5L5 12.5M19 12.5L13 18.5M19 12.5L13 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col class="text-center my-5" v-if="!errorAlert && sendForm">
                  <h3 class="form-starter__title">
                    Dziękujemy za wypełnienie formularza. <br />
                    Na maila wysłaliśmy potwierdzenie i link do formularza zgłoszeniowego dla zespołu. <br /><br />
                    W razie nieotrzymania wiadomości, prosimy o sprawdzenie folderu SPAM lub kontakt z nami.
                  </h3>
                </b-col>
                <b-col class="text-center my-5" v-if="errorAlert && sendForm">
                  <h3 class="form-starter__title">
                    Ups... Coś poszło nie tak!<br />
                    Spróbuj ponownie później!
                  </h3>
                </b-col>
              </b-row>
              <b-col v-if="sendForm" class="mt-5 mb-3 d-inline-flex justify-content-center">
                <router-link class="no-deco" to="/"><b-button class="button-new-primary button-new-primary--big" variant="primary">Wróć na stronę główną</b-button></router-link>
              </b-col>
            </b-col>
          </b-row>
        </b-container>
      </form>
    </section>
  </div>
</template>

<script>
import mainImage from '../../assets/media/images/form-app-image.jpg'
import wp_api_client from "@/store/wp_api_client";
const api = new wp_api_client(process.env.VUE_APP_API_URL)

const voivodeships = [
  'dolnośląskie',
  'kujawsko-pomorskie',
  'lubelskie',
  'lubuskie',
  'łódzkie',
  'małopolskie',
  'mazowieckie',
  'opolskie',
  'podkarpackie',
  'podlaskie',
  'pomorskie',
  'śląskie',
  'świętokrzyskie',
  'warmińsko-mazurskie',
  'wielkopolskie',
  'zachodniopomorskie',
];

const form = {
  school_name: null,
  school_voivodeship:null,
  first_name: null,
  email: null,
  phone: null,
  position: null,
  regulation_consent: false,
  personal_data_consent: false,
};

export default {
  name: "RegisterStarterForm",
  data() {
    return {
      isSelectFocused: false,
      form: form,
      mainImage: mainImage,
      voivodeships: voivodeships,
      activeIndex: 0,
      errorAlert: false,
      sendForm: false,
      validForm: false,
      formTimeout: null
    }
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      if(this.validateFormValues("phone") && !this.errorAlert) {
        api.sendApplicationStarterForm(this.form)
            .then((res) => {
              if(res.status !== 200) {
                this.errorAlert = true
                this.sendForm = true;
                this.$refs.targetRef.scrollIntoView({ block: 'start', behavior: 'smooth' });
              } else {
                this.sendForm = true;
                this.form = {
                  school_name: null,
                  school_voivodeship:null,
                  first_name: null,
                  email: null,
                  phone: null,
                  position: null,
                  regulation_consent: null,
                  personal_data_consent: null,
                }
                this.$refs.targetRef.scrollIntoView({ block: 'start', behavior: 'smooth' });
              }
            }).catch(() => {
          this.sendForm = true;
          this.errorAlert = true
          this.validForm = false;
        })
      }
    },
    validateFormValues(excludeField) {
      for (const key in this.form) {
        if (key !== excludeField) {
          const value = this.form[key];
          if (value === null || value === undefined || value === false || value === "") {
            this.validForm = true;

            if (this.formTimeout !== null) {
              clearTimeout(this.formTimeout);
            }

            this.formTimeout = setTimeout(() => {
              this.validForm = false;
            }, 4000);

            return false;
          }
        }
      }
      return true;
    },
    onFocus() {
      this.isSelectFocused = true;
    },
    onBlur() {
      this.isSelectFocused = false;
    },
    onSelectChange() {
      this.isSelectFocused = false;
      this.isSelectFocused = !this.isSelectFocused;
    },
    toggleDropdown() {
      this.isSelectFocused = !this.isSelectFocused;
    }
  }
}
</script>

<style scoped lang="scss">
.form-starter {
  padding-bottom: 70px;
  padding-top: 70px;
  background: $main-bg;
  color: $main-color;

  @include media-breakpoint-down(sm){
    padding: 70px 12px;
  }

  &__wrapper {
    position: relative;
    padding: 64px;
    background: $white;
    border-radius: 20px;

    @include media-breakpoint-down(lg){
      padding: 32px;
    }
  }

  .shape-1 {
    position: absolute;
    right: 0;
    top: 10%;
    object-fit: cover;

    @include media-breakpoint-down(md){
      display: none;
    }
  }

  &__title {
    font-size: 1.75em;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 40px;
  }

  &__text {
    font-size: 1.125em;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    margin-bottom: 40px;
  }
}
.box-image {
  position: relative;
}
.main-image {
  height: 400px;
  width: 100%;
  object-fit: cover;
}
.main-header {
  position: absolute;
  top: 50%;
  left: 13%;
  transform: translateY(-50%);
  font-weight: 700;
  color: white;
  font-size: 48px;
  @include media-breakpoint-down(sm) {
    left: 2%;
    font-size: 32px;
  }
}
.link-statute {
  color: black;
  text-decoration: underline;
}
.team-size-btn {
  width: 120px;
  text-align: center;
  cursor: pointer;
  border: 2px solid black;
  border-radius: 20px;
  padding: 16px;
  &.active {
    border-color: #A18037;
  }
}
label{
  position: relative;

  textarea:focus + .maxlength-label {
    color: #C50000;
  }

  .maxlength-label{
    position: absolute;
    right: 16px;
    bottom: 8px;
    //color: #C50000;
  }
}
.form-type-buttons {
  margin-top: 6rem;
  margin-bottom: 6rem;
  button {
    max-width: 100%;
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: lighter;
  }
}
.form-section-title{
  text-align: center;
  margin-top: 7rem;
  margin-bottom: 3rem;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: calc(100% + 16px);
    left: 0;
    width: 100%;
    height: 3px;
  }
  &.yellow {
    &:after {
      background-color: #FCC157;
    }
  }
  &.blue {
    &:after {
      background-color: #007CC2;
    }
  }
  &.red {
    &:after {
      background-color: #FF4337;
    }
  }
}
.hr_container {
  position: relative;
  &:after {
    position: absolute;
    top:50%;
    display: block;
    content: ' ';
    width: 100%;
    height: 1px;
    background: $black;
  }
}
.number {
  background: $white;
  position: relative;;
  z-index: 1;
  width: 64px;
  height: 64px;
  line-height: 64px;
  color: #C5C5C5;
  border: 1px solid #C5C5C5;
  border-radius: 100%;
  font-family: Samsung Sharp Sans;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  margin: 0 auto;
  &.active{
    color: $black;
    border-color: $black;
  }
  &.finished{
    color: #878424;
    border-color: #878424;
  }
}
.form-control, .custom-select {
  padding: 16px;
  background-color: $white;
  border: 1px solid #59595C;
  &::placeholder{
    color: #979797;
  }
}
.input {
  border-radius: 10px;
}

.label {
  font-size: 16px;
  font-weight: 500;
  font-family: "Samsung Sharp Sans";
}

.select {
  font-weight: 500;
  font-family: "Samsung Sharp Sans";

  & option:first-child {
    color: #979797;
  }
}

.box {

  .active {
    svg path {
      fill: #A18037
    }
  }
}

.input-control {
  display: flex;
  align-items: center;
  margin-top: 40px;
  gap: 16px;
  font-size: 18px;
  font-family: "Samsung Sharp Sans";

  & div {
    display: flex;
  }

  & a {
    color: black;
    text-decoration: underline;
  }

  &.img {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: #000;
    width: 25px;
    height: 25px;
    border: 1px solid black;
    border-radius: 0.15em;
    display: grid;
    place-content: center;

    &::before {
      content: "";
      width: 25px;
      height: 25px;
    }

    &:checked::before {
      border-radius: 0.15em;
      background: black no-repeat center url("../../assets/media/images/mark.svg");
    }
  }

  &--text {
    font-size: .78em!important;
    font-style: normal;
    font-weight: 500!important;
    line-height: 20px;
    margin-top: 2px;
  }
}

.star-box {
  position: relative;
}

.star {
  position: absolute;
  top: 40%;
  right: -2%;
  font-weight: 700;
  font-size: 17px;
  font-family: "Samsung Sharp Sans";
}

.input-box {
  position: relative;
  margin-top: 32px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: $white;
  word-break: break-word;

  & input {
    height: 40px;
    border: none;
    border-bottom: 1px solid #D4D4D4;
    padding: 0;
    background-color: $white;
    border-radius: 0;
    margin-top: 12px;

    &:focus {
      box-shadow: none;
      background-color: transparent;
      border-color: #D4D4D4;
    }

    &[type='checkbox'] {
      -webkit-appearance: none;
      appearance: none;
      background-color: #fff;
      margin: 0;
      font: inherit;
      color: #000;
      width: 20px;
      height: 20px;
      border: 1px solid #007CC2;
      border-radius: 0.15em;
      display: grid;
      place-content: center;

      &::before {
        content: "";
        width: 20px;
        height: 20px;
      }

      &:checked::before {
        border: none;
        border-radius: 0.15em;
        background: #007CC2 no-repeat center url("../../assets/media/images/mark-blue.svg");
      }
    }
  }

  & p {
    font-size: .88em;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 0;

    & .color {
      color: #FF4337;
    }
  }

  & input:focus + p, & input:not(:placeholder-shown) + p  {
    display: block;
    top: -22%;
  }

  & textarea:focus + p, & textarea:not(:placeholder-shown) + p {
    display: block;
    top: -18%;
  }

  & input:focus::placeholder, & textarea:focus::placeholder {
    opacity: 0;
  }

  & .select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    padding: 0;
    height: 40px;
    border-bottom: 1px solid #D4D4D4;
    background: $white;
    border-radius: 0;
    margin-top: 12px;

    &:focus {
      box-shadow: none;
      background-color: transparent;
      border-color: #D4D4D4;
    }
  }

  & .select-icon {

    &::after {
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5889 13.0892C10.2635 13.4146 9.73586 13.4146 9.41042 13.0892L4.41042 8.08917C4.08498 7.76374 4.08498 7.2361 4.41042 6.91066C4.73586 6.58523 5.26349 6.58523 5.58893 6.91066L9.99967 11.3214L14.4104 6.91066C14.7359 6.58523 15.2635 6.58523 15.5889 6.91066C15.9144 7.2361 15.9144 7.76374 15.5889 8.08917L10.5889 13.0892Z' fill='%23393947'/%3E%3C/svg%3E%0A");
      position: absolute;
      right: 0;
      top: 55%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
    }

    &.rotate::after {
      transform: translateY(-50%) rotate(180deg);
    }
  }

  & .radio-box {
    gap: 24px;
    & label {
      margin-bottom: 0;
    }

    & input[type="radio"] {
      height: auto;
      margin: 0;
      padding: 0;
      border-bottom: none;
      background: none;
      cursor: pointer;

      &::before {
        width: 28px;
        height: 28px;
        border-radius: 0;
        background: no-repeat center url("../../assets/media/images/radio-blue.svg");
      }

      &:checked::before {
        border-radius: 0;
        background: no-repeat center url("../../assets/media/images/radio-mark-blue.svg");
      }
    }
  }

  &--consent {
    font-size: .88em;
    font-style: normal;
    font-weight: 500!important;
    line-height: normal;
    margin-bottom: 0;
    margin-left: 8px;

    & a {
      color: $main-color;
      font-weight: 700;
      text-decoration: underline;
    }
  }
}

.color-span {
  color: #C50076;
}

.link {
  color: black;
  text-decoration: underline;

  &:visited, &:hover {
    color: black;
  }
}
.button-new-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px 9px 24px;
  background-color: $secondary;
  border: none;
  margin-right: -12px;
  line-height: normal;
  color: $white;
  transition: all .4s ease;
  text-decoration: none!important;

  &--big {
    line-height: 32px;
    padding: 9px 32px;
    margin-right: 0;
  }

  &:hover {
    background-color: #13588A;
  }
}
.error {
  color: #df2019;
}
.no-deco {
  text-decoration: none;
}
.form-starter-box {
  @include media-breakpoint-down(sm){
    padding: 0;
  }
}
</style>
